<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Search Form
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">

                                        <v-col md="3" cols="12">
                                            <v-autocomplete
                                            label="Select Year"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="year.value.value"
                                            :items="getYearsList"
                                            item-value="value"
                                            :error-messages="year.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            ></v-autocomplete>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <v-autocomplete
                                            label="Select Month"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="month.value.value"
                                            :items="getMonthsList"
                                            :item-title="(item)=> item.title"
                                            item-value="value"
                                            :error-messages="month.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            ></v-autocomplete>
                                        </v-col>

                                        <v-col md="2" cols="12">
                                            <v-btn
                                            class="bg-brand w-100"
                                            type="submit"
                                            ref="searchButton"
                                            >Search</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Monthly Salary Report
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="px-2">
                                <v-row class="py-2 justify-items-between">

                                    <v-col cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                            >
                                                <v-btn
                                                prepend-icon="mdi mdi-printer"
                                                variant="flat"
                                                color="indigo"
                                                @click="printReport"
                                                >PRINT</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                >CSV</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn>
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                </v-row>

                                <div id="printable-area">
                                    <v-card class="my-2" elevation="0">
                                        <v-card-title class="bg-primary text-white text-center">
                                            <div class="w-100">
                                                <div class="text-h5 font-weight-bold">{{  titleShow(month.value.value, year.value.value) }}</div>
                                            </div>
                                        </v-card-title>
                                    </v-card>

                                    <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :item-per-page="1"
                                    :loading="loading"
                                    :search="search"
                                    :hover="true"
                                    density="compact"
                                    hide-default-footer
                                    class="custom-bordered-table"
                                    >
                                        <template v-slot:item="{ item }">
                                            <tr>

                                                <td  class="text-center" >{{ item.id }}</td>
                                                <td class="text-left">{{ item.employee.code }}</td>
                                                <td class="text-left">{{ item.employee.name }}</td>
                                                <td class="text-left">{{ item.designation.name }}</td>
                                                <td class="text-left">{{ item.department.name }}</td>
                                                <td class="text-left">{{ item.gross_salary }}</td>
                                                <td class="text-left">{{ item.basic }}</td>
                                                <td class="text-right">{{ item.home_allowance }}</td>
                                                <td class="text-right">{{ item.medical_allowance }}</td>
                                                <td class="text-right">{{ item.conveyance }}</td>
                                                <td class="text-right">{{ item.total_days }}</td>
                                                <td class="text-right">{{ item.present_days }}</td>
                                                <td class="text-right">{{ item.absent_days }}</td>
                                                <td class="text-right">{{ item.total_deduction }}</td>
                                                <td class="text-right">{{ item.total_ot_hour }}</td>
                                                <td class="text-right">{{ item.total_ot_amount }}</td>
                                                <td class="text-right">{{ item.total_net_payable }}</td>
                                                <td class="text-right"></td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, computed } from "vue";
import { toast } from "vue3-toastify";

export default {
    data: () => ({
        panel: [0],
        panel2: [0],
        search: "",
        headers: [
            { title: "#SL", align: "center", key: "id", width: "5%", sortable: false },
            { title: "Employee Code", key: "employee.code", align: "center", sortable: false },
            { title: "Name", key: "employee.name", align: "center", sortable: false, width: "140px" },
            { title: "Designation", key: "designation.name", align: "center", sortable: false },
            { title: "Department", key: "department.name", align: "center", sortable: false },
            { title: "Gross Salary", key: "gross_salary", align: "center", sortable: false },
            { title: "Basic", key: "basic", align: "center", sortable: false },
            { title: "House", key: "home_allowance", align: "center", sortable: false },
            { title: "Medical", key: "medical_allowance", align: "center", sortable: false },
            { title: "Conv", key: "conveyance", align: "center", sortable: false },
            { title: "Days in Month", key: "total_days", align: "center", sortable: false },
            { title: "Present Days", key: "present_days", align: "center", sortable: false },
            { title: "Absent Days", key: "absent_days", align: "center", sortable: false },
            { title: "Total Deduction", key: "total_deduction", align: "center", sortable: false },
            { title: "OT hour", key: "total_ot_hour", align: "center", sortable: false },
            { title: "OT Amount", key: "total_ot_amount", align: "center", sortable: false },
            { title: "Net Payable", key: "total_net_payable", align: "center", sortable: false },
            { title: "Signature", key: "signature", align: "center", sortable: false, width: "230px" },
        ],
        years: [],
        months: [
            { title: "January", value: 1 },
            { title: "February", value: 2 },
            { title: "March", value: 3 },
            { title: "April", value: 4 },
            { title: "May", value: 5 },
            { title: "June", value: 6 },
            { title: "July", value: 7 },
            { title: "August", value: 8 },
            { title: "September", value: 9 },
            { title: "October", value: 10 },
            { title: "November", value: 11 },
            { title: "December", value: 12 },
        ],
    }),
    computed: {
        getSchema() {
            return this.$store.getters.getMonthlySalaryReport;
        },
        getYearsList() {
            const startYear = 2025;
            const currentYear = new Date().getFullYear();

            for (let y = startYear; y <= currentYear; y++) {
                this.years.push(y);
            }

            return this.years;
        },
        getMonthsList() {
            return this.months;
        },
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl || '';
        }
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                // Add your validation rules here
            }),
        });

        const month = useField("month");
        const year = useField("year");
        const loading = ref(false);
        const store = useStore();

        const submit = handleSubmit((values) => {
            loading.value = true;
            store
                .dispatch("getMonthlySalaryReport", values)
                .then((response) => {
                    loading.value = false;
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error?.response?.data?.message || "An error occurred");
                });
        });

        return {
            month,
            year,
            submit,
            loading,
        };
    },
    methods: {
        titleShow(month, year) {
            if (month && year) {
                return `Monthly Salary Report for ${this.getMonthsList[month-1].title}, ${year}`;
            } else if (year) {
                return `Monthly Salary Report for ${year}`;
            } else if (month) {
                return `Monthly Salary Report for ${this.getMonthsList[month-1].title}`;
            } else {
                return `Monthly Salary Report`;
            }
        },
        printReport() {
            const printContent = document.getElementById("printable-area").innerHTML;
            
            const firstItem = this.getSchema[0];
            const companyInfo = firstItem?.branch?.company;
            
            const companyName = companyInfo?.name;
            const companyAddress = companyInfo?.address;
            const companyMobile = companyInfo?.mobile;
            const companyEmail = companyInfo?.email;
            const companyWebsite = companyInfo?.website;

            let companyLogo = '';
            if (companyInfo?.logo) {
                companyLogo = `${this.getFileServerUrl.replace(/\/$/, '')}/${companyInfo.logo}`;
            } else {
                companyLogo = `${this.getFileServerUrl.replace(/\/$/, '')}/uploads/demo_images/user.png`;
            }
            
            const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}, left=0, top=0`);

            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Monthly Salary Report - ${this.year.value.value || new Date().getFullYear()}</title>
                    <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
                    <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    
                    body {
                        font-family: 'Times New Roman', serif;
                        background: white;
                        margin: 0;
                        padding: 20px;
                    }
                    .report-paper {
                        background-color: white;
                        color: black;
                        max-width: 100%;
                        width: 100%;
                        margin: auto;
                    }
                    .header-section {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        border-bottom: 2px solid #eee;
                        padding-bottom: 10px;
                        margin-bottom: 16px;
                    }
                    .company-info {
                        flex: 1;
                    }
                    .company-name {
                        color: #333;
                        font-size: 14px;
                        font-weight: bold;
                        text-transform: uppercase;
                        margin: 0 0 4px 0;
                    }
                    .company-text {
                        font-size: 12px;
                        color: #555;
                        margin: 2px 0;
                        display: flex;
                        align-items: center;
                    }
                    .logo-container img {
                        max-height: 70px;
                        max-width: 150px;
                    }
                    .report-title {
                        color: #333;
                        font-size: 20px;
                        font-weight: bold;
                        text-align: center;
                        margin: 16px 0;
                    }
                    
                    .report-info {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 15px;
                        font-size: 13px;
                        color: #333;
                    }
                    
                    .report-info-left {
                        font-weight: 500;
                    }
                    
                    .report-info-right {
                        font-weight: 500;
                    }

                    /* Bank headers and totals */
                    .bank-header {
                        background-color: #eceff1;
                        padding: 6px 8px;
                        margin: 8px 0 6px 0;
                        border: 1px solid #000;
                    }

                    .bank-header h4 {
                        font-size: 14px;
                        font-weight: 700;
                    }

                    .row-total td {
                        font-weight: 700;
                        background-color: #f5f5f5 !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }

                    .v-card {
                        display: none;
                    }
                    
                    .font-weight-bold {
                        font-weight: bold;
                    }
                    
                    .w-100 {
                        width: 100%;
                    }
                    
                    .text-center {
                        text-align: center;
                    }
                    
                    .text-left {
                        text-align: left;
                    }
                    
                    .text-right {
                        text-align: right;
                    }
                    
                    .custom-bordered-table {
                        width: 100%;
                        margin-top: 0;
                    }
                    
                    .custom-bordered-table table {
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 11px;
                    }
                    
                    .custom-bordered-table thead {
                        display: table-header-group;
                    }
                    
                    .custom-bordered-table thead th {
                        background-color: #f5f5f5 !important;
                        border: 1px solid #000000 !important;
                        padding: 8px 4px;
                        font-weight: bold;
                        color: #000;
                        vertical-align: middle;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    
                    .custom-bordered-table tbody td {
                        border: 1px solid #000000 !important;
                        padding: 6px 4px;
                        vertical-align: middle;
                        color: #000;
                    }
                    
                    .custom-bordered-table tr {
                        page-break-inside: avoid;
                        page-break-after: auto;
                    }
                    
                    .merged-cell {
                        font-weight: 500;
                    }
                    
                    /* Hide pagination and other v-data-table controls */
                    .v-data-table-footer,
                    .v-data-table__wrapper + div,
                    .v-pagination {
                        display: none !important;
                    }

                    .letter-meta {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        margin-bottom: 20px;
                        font-size: 12px;
                        color: #000;
                        padding: 10px 0;
                    }

                    .letter-address {
                        margin-top: 10px;
                        margin-bottom: 20px;
                        font-size: 12px;
                        color: #000;
                        line-height: 1.6;
                    }

                    .letter-greeting {
                        margin: 20px 0 14px 0;
                        font-size: 12px;
                    }

                    .letter-paragraph {
                        font-size: 12px;
                        color: #000;
                        line-height: 1.7;
                        margin-bottom: 16px;
                    }
                    
                    @page {
                        size: landscape;
                        margin: 0.5cm;
                    }
                    
                    @media print {
                        body {
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                            background: white !important;
                            padding: 0;
                        }
                        .page-header {
                            display: table-header-group;
                        }
                        .page-content {
                            display: table-row-group;
                        }
                        
                        .custom-bordered-table thead {
                            display: table-header-group;
                        }
                        
                        .custom-bordered-table thead th {
                            background-color: #f5f5f5 !important;
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }
                        
                        .custom-bordered-table tr {
                            page-break-inside: avoid;
                            page-break-after: auto;
                        }
                        
                        table {
                            page-break-inside: auto;
                        }
                    }
                    </style>
                </head>
                <body>
                    <!-- Company Header -->
                    <div class="container-fluid position-relative">
                        <div class="header-section">
                            <div class="company-info">
                                <h4 class="company-name">${companyName}</h4>
                                <p class="company-text">${companyAddress}</p>
                                <p class="company-text">
                                    <span class="mdi mdi-phone-outline"></span>
                                    ${companyMobile}
                                </p>
                                <p class="company-text">
                                    <span class="mdi mdi-email-outline"></span>
                                    ${companyEmail}
                                </p>
                                ${companyWebsite ? `<p class="company-text">
                                    <span class="mdi mdi-web"></span>
                                    ${companyWebsite}
                                </p>` : ''}
                            </div>
                            <div class="logo-container">
                                <img src="${companyLogo}" alt="Company Logo" />
                            </div>
                        </div>
                        
                        <!-- Report Title -->
                        <div class="report-title-section">
                            <h2 class="report-title">${this.titleShow(this.month.value.value, this.year.value.value)}</h2>
                        </div>
                        
                        <!-- Report Info -->
                        <div class="report-info">
                            <div class="report-info-right">Total Records: ${this.getSchema.length}</div>
                        </div>
                    </div>
                    
                    <!-- Report Content -->
                    ${printContent}
                </body>
                </html>
            `);

            printWindow.document.close();
            printWindow.moveTo(0, 0);
            printWindow.focus();
            
            setTimeout(() => {
                printWindow.print();
                printWindow.onafterprint = () => {
                    printWindow.close();
                };
            }, 1000);
        },


        exportToExcel() {
            const data = [
                ["#SL", "Employee Code", "Name", "Designation", "Department", "Gross Salary", "Basic", "House", "Medical", "Conv", "Days in Month", "Present Days", "Absent Days", "Total Deduction", "OT hour", "OT Amount", "Net Payable", "Signature"]
            ];

            this.getSchema.forEach((item, index) => {
                data.push([
                    index + 1,
                    item.employee.code,
                    item.employee.name,
                    item.designation.name,
                    item.department.name,
                    item.gross_salary,
                    item.basic,
                    item.home_allowance,
                    item.medical_allowance,
                    item.conveyance,
                    item.total_days,
                    item.present_days,
                    item.absent_days,
                    item.total_deduction,
                    item.total_ot_hour,
                    item.total_ot_amount,
                    item.total_net_payable,
                    '',
                ]);
            });

            this.$exportTableToExcel(data, "salary_pay_register_" + this.$fileDate());
        },

        exportToCSV() {
            const data = [
                ["#SL", "Employee Code", "Name", "Designation", "Department", "Gross Salary", "Basic", "House", "Medical", "Conv", "Days in Month", "Present Days", "Absent Days", "Total Deduction", "OT hour", "OT Amount", "Net Payable", "Signature"]
            ];

            this.getSchema.forEach((item, index) => {
                data.push([
                    index + 1,
                    item.employee.code,
                    item.employee.name,
                    item.designation.name,
                    item.department.name,
                    item.gross_salary,
                    item.basic,
                    item.home_allowance,
                    item.medical_allowance,
                    item.conveyance,
                    item.total_days,
                    item.present_days,
                    item.absent_days,
                    item.total_deduction,
                    item.total_ot_hour,
                    item.total_ot_amount,
                    item.total_net_payable,
                    '',
                ]);
            });

            this.$exportTableToCSV(data, "salary_pay_register_" + this.$fileDate());
        },
    },

    mounted() {
        // this.$refs.searchButton.$el.click();
    },
};
</script> 

<style scoped>
.custom-bordered-table ::v-deep() table {
    border-collapse: collapse;
}

.custom-bordered-table ::v-deep() thead th,
.custom-bordered-table ::v-deep() tbody td {
    border: 1px solid #000000 !important;
    padding: 8px;
}

.custom-bordered-table {
    overflow-x: auto;
    padding: 12px 0;
}

.custom-bordered-table ::v-deep() .merged-cell {
    font-weight: 500;
}

/* Print Styles */
@media print {
    /* Hide unnecessary elements */
    .v-expansion-panel:first-child,
    .v-btn-group,
    .v-navigation-drawer,
    .v-app-bar,
    .v-footer {
        display: none !important;
    }

    /* Expand the report panel */
    .v-expansion-panel-text {
        display: block !important;
        max-height: none !important;
    }

    /* Full width for print */
    .v-container {
        max-width: 100% !important;
        padding: 0 !important;
    }

    /* Table styles for print */
    .custom-bordered-table ::v-deep() table {
        width: 100% !important;
        page-break-inside: auto;
        font-size: 10px;
    }

    .custom-bordered-table ::v-deep() thead {
        display: table-header-group;
    }

    .custom-bordered-table ::v-deep() tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }

    .custom-bordered-table ::v-deep() thead th,
    .custom-bordered-table ::v-deep() tbody td {
        border: 1px solid #000000 !important;
        padding: 6px 4px;
    }

    /* Card title styling */
    .v-card-title {
        background-color: #1976d2 !important;
        color: white !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    /* Remove shadows and elevations */
    .v-card {
        box-shadow: none !important;
    }

    /* Adjust page margins */
    @page {
        margin: 0.5cm;
        size: landscape;
    }
}
</style>